import { Organization } from "types/organization";
import client from "./client";

export const fetchOrganizations = async (): Promise<Organization[]> => {
  return client.get("/organizations").then(response => response.data.response);
};

export const getOrganization = async (id: string): Promise<Organization> => {
  return client
    .get(`/organizations/${id}`)
    .then(response => response.data.response);
};

export const updateOrganization = async ({
  id,
  ...rest
}: Organization): Promise<Organization> => {
  return client
    .post(`/organizations/update/${id}`, { ...rest })
    .then(response => response.data.response);
};
